var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0381 3.78809C15.5406 3.78809 3.78809 15.5407 3.78809 30.0381C3.78809 44.5355 15.5406 56.2881 30.0381 56.2881C44.5356 56.2881 56.2881 44.5355 56.2881 30.0381C56.2881 15.5406 44.5355 3.78809 30.0381 3.78809V3.78809ZM44.7283 23.409L28.1819 39.9553C27.274 40.8633 25.8019 40.8633 24.8938 39.9553L15.3478 30.4093C14.4399 29.5013 14.4399 28.0293 15.3478 27.1213C16.2558 26.2132 17.7279 26.2133 18.6359 27.1213L26.5378 35.0232L41.4401 20.1208C42.3481 19.2129 43.8202 19.2129 44.7282 20.1208C45.6362 21.0288 45.6362 22.501 44.7283 23.409Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioChecked);
export default __webpack_public_path__ + "static/media/radio-checked.36b173ae7330308589390faaba066599.svg";
export { ForwardRef as ReactComponent };